import Client from './ApiClient'

const resource = 'conversation-reports'

const getAll = (page = 1, perPage = 10) => {
  return Client.get(`${resource}?page=${page}&perPage=${perPage}`)
}

const answerReport = (id, data) => {
    return Client.post(`${resource}/${id}/answer`, data)
}

export default { getAll, answerReport }
